import { render } from "./kantu-phone-login.vue?vue&type=template&id=e08107f6&scoped=true&ts=true"
import script from "./kantu-phone-login.vue?vue&type=script&lang=ts"
export * from "./kantu-phone-login.vue?vue&type=script&lang=ts"

import "./kantu-phone-login.vue?vue&type=style&index=0&id=e08107f6&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08107f6"]])